/* eslint-disable import/no-cycle */
/* eslint-disable import/prefer-default-export */
import { createPromiseRequest } from './util/createPromiseRequest';
import { hasAccessToken } from '../../../utils/token';

export const fetchStatuses = async () => {
	const url = '/statuses';

	if (hasAccessToken()) {
		const fetchData = createPromiseRequest({
      url,
      method: 'GET'
		});

    return fetchData().then((statues = []) => { 
      return statues;
    });
	}
	return Promise.reject(new Error('Missing Token'));
};

